export default class CreateCaseLabels{
    qty: number=1;
    
}